import { Input, Modal, Table } from 'antd';
import styled from 'styled-components';

export const DynamicPropertiesContainer = styled.div`
  margin: 16px;
  padding: 24px;
  border-radius: 4px;
  background: #fff;

  .dynamic-properties-table-pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0 0;

    .ant-pagination-item-container {
      width: 100%;
    }

    .ant-pagination-total-text {
      p {
        color: var(--grey-3-text, #b8bec5);
        line-height: 32px;
        margin: 0;
      }
    }

    .ant-pagination-item,
    button.ant-pagination-item-link {
      border-radius: 4px;
      border: 1px solid var(--grey-5-border, #d0d7e3);
    }

    .ant-pagination-options-size-changer .ant-select-selector {
      border-radius: 4px;
      border: 1px solid var(--grey-5-border, #d0d7e3);
    }

    .ant-pagination-options-size-changer.ant-select-focused
      .ant-select-selector {
      border: 1px solid var(--brand-2, #21b4bd);
      box-shadow: 0 0 0 2px var(--brand-2-02, #21b4bd33);
    }

    .ant-pagination-item-active {
      border: 1px solid var(--brand-2, #21b4bd);
    }
  }
`;

export const DynamicPropertiesActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: end;
  margin: 24px 0 0 0;
`;

export const TableActionsWrapper = styled.div`
  display: flex;
  gap: 18px;
  font-size: 16px;
`;

export const TableStyled = styled(Table)`
  .ant-table-thead {
    /* Fix the table header at the top */
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .ant-table-content {
    border-left: 1px solid #eceff4;
    border-right: 1px solid #eceff4;
    height: 400px;
    overflow: auto;

    /* Customize the scrollbar */
    ::-webkit-scrollbar {
      width: 3px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #bbb;
      border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: #999;
    }
  }

  .ant-table-thead {
    tr {
      th {
        font-size: 12px;
        line-height: 1;
        color: var(--grey2, #748aa1);
        background: var(--light-grayish-blue-color11, #eef4fa);
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: #eceff4;
        padding: 10px 16px;
      }
    }
  }

  .ant-table-tbody {
    tr {
      td {
        color: var(--grey-1-text, #31394d);
        font-size: 13px;
        line-height: 20px;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: #eceff4;
        padding: 12px 16px;
        word-break: break-word;

        .finalValue-input {
          min-width: 200px;
        }
      }
    }
  }
`;

export const InputStyled = styled(Input)`
  padding: 4px 12px;
  border-radius: 4px;

  &:hover,
  &:focus {
    border-color: var(--brand-2, #21b4bd);
  }

  &:focus {
    box-shadow: 0 0 0 2px var(--brand-2-02, #21b4bd33);
  }
`;

export const InfoModalStyled = styled(Modal)`
  .ant-modal-header {
    background: var(--grey-6-table, #eef4fa);
  }

  .basic-info-container {
    border-right: 1px solid #d0d7e3;
  }

  .basic-info-content h4,
  .description-content h4,
  .format-content h4 {
    color: var(--grey-1-text, #31394d);
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .basic-info-content p,
  .description-content p,
  .format-content p {
    color: #0c8ed7;
    font-size: 10px;
    line-height: 20px;
    margin: 0;
  }

  .basic-info-content {
    margin-bottom: 50px;
  }
`;

export const InfoAlertContainer = styled.div`
  margin-top: auto;
  padding-top: 16px;

  .info-alert {
    color: #335777;
    font-size: 10px;
    font-weight: 500;

    .info-icon {
      color: #335777;
      font-size: 14px;
    }
  }
`;
